
<div>
  <div class="sr-only">
    <label for="formatDecimalPlaces">Number of Decimal Places</label>
  </div>
  <input
    id="formatDecimalPlaces"
    type="number"
    @blur="model.defaultNumericValidation()"
    v-model.number="model.decimal_places"
    placeholder="Number of Decimal Places"
    :disabled="disabled"
  />
</div>
